export const ORDER_STATUS_DROP_DOWN_ID =
  'order-management-detail-view-order-status-dropdown';
